import { ENV, EnvConfig } from '@d/appConfigs/envConfig';
import { createContext } from 'react';

export const DialogEngineEnvironment: ENV = EnvConfig.env;
export const DialogEngineEnvContext = createContext(DialogEngineEnvironment);
